import { combineReducers } from "redux";

import schemasReducer from "./schemas";
import financicalSchemasReducer from "./financicalSchemas";
import seasonalitySchemasReducer from "./seasonalitySchemas";
import projectsReducer from "./projects";
import dealroomReducer from "./dealroom";

const rootReducer = combineReducers({
  schemas: schemasReducer,
  financicalSchemas: financicalSchemasReducer,
  seasonalitySchemas: seasonalitySchemasReducer,
  projects: projectsReducer,
  dealroom: dealroomReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/store/reducers/index.js